































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import storeProtokolKemoterapi from "@/store/modules/ProtokolKemoterapi";
import SvcProtokolKemoterapi from "@/services/ProtokolKemoterapi";
import SvcMasterRegimen from "@/services/MasterRegimenKemoterapi";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import moment from "moment";

@Component({
  components: {
    PerawatAutoComplete,
    DokterAutoComplete,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardProtokolKemoterapi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  valid = true;
  loading = false;
  editId = null;

  // Regimen master data
  listRegimen: any[] = [];
  loadingRegimen = false;
  regimenDetail: any = null;

  // Form data
  form = {
    tanggal: moment().format("YYYY-MM-DDTHH:mm"),
    diagnosa: "",
    siklus: "",
    tinggi_badan: null as number | null,
    berat_badan: null as number | null,
    regimen_id: null as number | null,
    dosis_aktual: [] as any[],
    program_pemberian: [] as any[],
    monitoring: [{ pukul: null, tanda_vital: null, efek_samping_ada: null, efek_samping_tidak: null, tindakan_korektif: null }] as any[],
  };

  perawat: any = {};
  dpjp: any = userModule.user;

  dialogHapus = false;
  deleteTarget: any = null;

  tableHeaders = [
    { text: "Tanggal", value: "tanggal", width: "150px" },
    { text: "Regimen", value: "regimen" },
    { text: "Siklus", value: "siklus", width: "80px" },
    { text: "Perawat", value: "perawat_nama" },
    { text: "Aksi", value: "actions", sortable: false, width: "120px" },
  ];

  get stateuser() {
    return userModule.user;
  }

  get storeProtokol() {
    return storeProtokolKemoterapi;
  }

  get listProtokol() {
    return storeProtokolKemoterapi.listProtokol;
  }

  get lptCalculated() {
    const tb = this.form.tinggi_badan;
    const bb = this.form.berat_badan;
    if (!tb || !bb || tb < 1 || bb < 1) return null;
    return Math.sqrt((Number(bb) * Number(tb)) / 3600).toFixed(2);
  }

  setPerawat(val) {
    this.perawat = val;
  }

  setDpjp(val) {
    this.dpjp = val;
  }

  formatDate(dt) {
    return dt ? moment(dt).format("DD-MM-YYYY HH:mm") : "-";
  }

  renderTindakan(pp) {
    let text = pp.tindakan || "";
    if (pp.obat_id && this.form.dosis_aktual.length) {
      const obat = this.form.dosis_aktual.find((d) => String(d.obat_id) === String(pp.obat_id));
      if (obat && obat.dosis_aktual) {
        text = text.replace(/\{dosis\}/g, obat.dosis_aktual);
      }
    }
    return text;
  }

  async mounted() {
    await this.loadRegimens();
    storeProtokolKemoterapi.getByRegister(this.register);
  }

  async loadRegimens() {
    this.loadingRegimen = true;
    try {
      const res = await SvcMasterRegimen.getAll();
      this.listRegimen = res.data || [];
    } finally {
      this.loadingRegimen = false;
    }
  }

  async onRegimenChange(regimenId) {
    if (!regimenId) {
      this.regimenDetail = null;
      this.form.dosis_aktual = [];
      this.form.program_pemberian = [];
      return;
    }
    try {
      const res = await SvcMasterRegimen.getDetail(regimenId);
      this.regimenDetail = res.data;
      this.buildDosisFromRegimen();
      this.buildProgramFromRegimen();
    } catch (e) {
      // error handled by service
    }
  }

  buildDosisFromRegimen() {
    if (!this.regimenDetail) return;
    const lpt = this.lptCalculated ? parseFloat(this.lptCalculated) : null;
    this.form.dosis_aktual = this.regimenDetail.obat.map((obat) => {
      let dosisAktual = null;
      if (obat.basis_kalkulasi === "lpt" && obat.dosis_per_unit && lpt) {
        dosisAktual = (obat.dosis_per_unit * lpt).toFixed(1);
      } else if (obat.basis_kalkulasi === "fixed" && obat.dosis_per_unit) {
        dosisAktual = obat.dosis_per_unit;
      } else if (obat.basis_kalkulasi === "bb" && obat.dosis_per_unit && this.form.berat_badan) {
        dosisAktual = (obat.dosis_per_unit * this.form.berat_badan).toFixed(1);
      }
      return {
        obat_id: obat.id,
        nama_obat: obat.nama_obat,
        dosis_standar: obat.dosis_standar,
        dosis_aktual: dosisAktual,
        rute: obat.rute,
        hari: obat.hari || obat.durasi || "",
        basis_kalkulasi: obat.basis_kalkulasi,
      };
    });
  }

  buildProgramFromRegimen() {
    if (!this.regimenDetail) return;
    this.form.program_pemberian = this.regimenDetail.program_pemberian.map((pp) => ({
      program_id: pp.id,
      nomor_urut: pp.nomor_urut,
      tindakan: pp.tindakan,
      obat_id: pp.obat_id,
    }));
  }

  @Watch("lptCalculated")
  onLptChange() {
    if (this.regimenDetail) {
      this.recalculateDoses();
    }
  }

  recalculateDoses() {
    const lpt = this.lptCalculated ? parseFloat(this.lptCalculated) : null;
    for (const dosis of this.form.dosis_aktual) {
      if (dosis.basis_kalkulasi === "lpt" && lpt) {
        const obat = this.regimenDetail.obat.find((o) => o.id === dosis.obat_id);
        if (obat && obat.dosis_per_unit) {
          dosis.dosis_aktual = (obat.dosis_per_unit * lpt).toFixed(1);
        }
      } else if (dosis.basis_kalkulasi === "bb" && this.form.berat_badan) {
        const obat = this.regimenDetail.obat.find((o) => o.id === dosis.obat_id);
        if (obat && obat.dosis_per_unit) {
          dosis.dosis_aktual = (obat.dosis_per_unit * this.form.berat_badan).toFixed(1);
        }
      }
    }
  }

  tambahProtokol() {
    this.resetForm();
    this.editId = null;
    this.showForm = true;
  }

  async editProtokol(item) {
    this.resetForm();
    this.editId = item.id;

    // Load full detail
    try {
      const res = await SvcProtokolKemoterapi.getById(item.id);
      const data = res.data;
      this.form.tanggal = data.tanggal ? moment(data.tanggal).format("YYYY-MM-DDTHH:mm") : "";
      this.form.diagnosa = data.diagnosa;
      this.form.siklus = data.siklus;
      this.form.tinggi_badan = data.tinggi_badan;
      this.form.berat_badan = data.berat_badan;
      this.form.regimen_id = data.regimen_id;

      // Load regimen detail
      if (data.regimen) {
        this.regimenDetail = data.regimen;
      }

      this.form.dosis_aktual = data.dosis_aktual || [];
      this.form.program_pemberian = data.program_pemberian || [];
      this.form.monitoring = data.monitoring || [{ pukul: null, tanda_vital: null, efek_samping_ada: null, efek_samping_tidak: null, tindakan_korektif: null }];
      this.perawat = data.perawat || {};
      this.dpjp = data.dpjp || {};
      this.showForm = true;
    } catch (e) {
      // handled by service
    }
  }

  cetakProtokol(item) {
    SvcProtokolKemoterapi.print(item.id);
  }

  hapusProtokol(item) {
    this.deleteTarget = item;
    this.dialogHapus = true;
  }

  async konfirmasiHapus() {
    if (!this.deleteTarget) return;
    try {
      await SvcProtokolKemoterapi.destroy(this.deleteTarget.id);
      appModule.NoticeDelay("Protokol berhasil dihapus");
      storeProtokolKemoterapi.getByRegister(this.register);
    } finally {
      this.dialogHapus = false;
      this.deleteTarget = null;
    }
  }

  simpan() {
    if (!this.perawat || !this.perawat["id"]) {
      appModule.sendErrorAlert("Pastikan Kolom Perawat Pelaksana Terisi");
      return;
    }

    const payload = {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateuser.unit_id,
      tanggal: this.form.tanggal,
      diagnosa: this.form.diagnosa,
      siklus: this.form.siklus,
      tinggi_badan: this.form.tinggi_badan,
      berat_badan: this.form.berat_badan,
      lpt: this.lptCalculated ? parseFloat(this.lptCalculated) : null,
      regimen_id: this.form.regimen_id,
      dosis_aktual: this.form.dosis_aktual,
      program_pemberian: this.form.program_pemberian,
      monitoring: this.form.monitoring,
      perawat_id: this.perawat["id"],
      dpjp_id: this.dpjp ? this.dpjp["id"] : null,
    };

    this.loading = true;
    const save = this.editId
      ? SvcProtokolKemoterapi.put(this.editId, payload)
      : SvcProtokolKemoterapi.post(payload);

    save
      .then((dt) => {
        if (dt.data.status != 1) {
          appModule.sendErrorAlert(dt.data.message);
        } else {
          appModule.NoticeDelay("Berhasil Menyimpan Protokol Kemoterapi");
          storeProtokolKemoterapi.getByRegister(this.register);
          this.showForm = false;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  cetak() {
    if (this.editId) {
      SvcProtokolKemoterapi.print(this.editId);
    }
  }

  addMonitoring() {
    this.form.monitoring.push({
      pukul: null,
      tanda_vital: null,
      efek_samping_ada: null,
      efek_samping_tidak: null,
      tindakan_korektif: null,
    });
  }

  hapusMonitoring(idx) {
    this.form.monitoring.splice(idx, 1);
  }

  resetForm() {
    this.form = {
      tanggal: moment().format("YYYY-MM-DDTHH:mm"),
      diagnosa: "",
      siklus: "",
      tinggi_badan: null,
      berat_badan: null,
      regimen_id: null,
      dosis_aktual: [],
      program_pemberian: [],
      monitoring: [{ pukul: null, tanda_vital: null, efek_samping_ada: null, efek_samping_tidak: null, tindakan_korektif: null }],
    };
    this.perawat = {};
    this.dpjp = userModule.user;
    this.regimenDetail = null;
    this.editId = null;
  }
}
